export {default as UploadAdapterPlugin} from './uploadadapterplugin';